"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.176.2
//   protoc               v4.23.4
// source: stats-proto/proto/stats.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSubsetUpdateStatus = exports.Resolution = exports.protobufPackage = void 0;
/* eslint-disable */
exports.protobufPackage = "blockscout.stats.v1";
var Resolution;
(function (Resolution) {
    Resolution["RESOLUTION_UNSPECIFIED"] = "RESOLUTION_UNSPECIFIED";
    Resolution["DAY"] = "DAY";
    Resolution["WEEK"] = "WEEK";
    Resolution["MONTH"] = "MONTH";
    Resolution["YEAR"] = "YEAR";
    Resolution["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Resolution || (exports.Resolution = Resolution = {}));
var ChartSubsetUpdateStatus;
(function (ChartSubsetUpdateStatus) {
    /** PENDING - No actions were taken yet for some charts */
    ChartSubsetUpdateStatus["PENDING"] = "PENDING";
    /** WAITING_FOR_STARTING_CONDITION - Some charts are waiting for starting condition */
    ChartSubsetUpdateStatus["WAITING_FOR_STARTING_CONDITION"] = "WAITING_FOR_STARTING_CONDITION";
    /** QUEUED_FOR_INITIAL_UPDATE - Some charts are waiting for their turn to be updated */
    ChartSubsetUpdateStatus["QUEUED_FOR_INITIAL_UPDATE"] = "QUEUED_FOR_INITIAL_UPDATE";
    /** RUNNING_INITIAL_UPDATE - Some charts are still running initial update */
    ChartSubsetUpdateStatus["RUNNING_INITIAL_UPDATE"] = "RUNNING_INITIAL_UPDATE";
    /** COMPLETED_INITIAL_UPDATE - Initial updates were completed for all charts */
    ChartSubsetUpdateStatus["COMPLETED_INITIAL_UPDATE"] = "COMPLETED_INITIAL_UPDATE";
    ChartSubsetUpdateStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ChartSubsetUpdateStatus || (exports.ChartSubsetUpdateStatus = ChartSubsetUpdateStatus = {}));
